import {connect} from 'react-redux';
import About from '../components/about/about';

const mapStateToProps = (state) => {
  return {
    entity: state.store.entity,
    defaultOptions: state.store.defaultOptions,
    press: state.store.press
  };
};

export default connect(mapStateToProps)(About);



// WEBPACK FOOTER //
// ./src/containers/about.js